import { openOAuthWindow } from '../utils/openOAuthWindow';

/**
 * Opens the OAuth popup synchronously for the headless flow.
 *
 * The popup must be opened in the same tick as the user gesture, otherwise the
 * browser (Safari in particular) blocks it. This warns when it detects the call
 * did not originate from a user activation so integrators get an actionable
 * message before the popup silently fails.
 */
export function openHeadlessOAuthWindow(appName) {
  const activation = window.navigator.userActivation;
  if (activation && !activation.isActive) {
    console.error('[unified-account] A headless auth flow (mode="headless") was started ' + 'outside of a user gesture, so the OAuth popup will likely be blocked ' + 'by the browser. Invoke the trigger (button onClick / openModal) ' + 'synchronously from a user interaction, without awaiting beforehand.');
  }
  return openOAuthWindow(appName);
}